import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import List from 'vant/lib/list'
import 'vant/lib/list/style'

import Cell from 'vant/lib/cell'
import 'vant/lib/cell/style'

import PullRefresh from 'vant/lib/pull-refresh'
import 'vant/lib/pull-refresh/style'
import Calendar from 'vant/lib/calendar'
import { Popup } from 'vant';

Vue.use(Popup);
import 'vant/lib/calendar/style'

import Field from 'vant/lib/field'

import Icon from 'vant/lib/icon'
import 'vant/lib/icon/style'

import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'

import 'vant/lib/swipe/style'
import 'vant/lib/tabs/style'
import 'vant/lib/picker/style'

import attentionPop from './components/attentionPop/index' // 关注公众号
import * as filters from './filters' // filters
import { get, post, postForm, postPay, postKnowledge, chaosiPost} from './utils/http.js'
import utils from './utils/util.js' // 工具类


Vue.prototype.$sensors = {
  track: function () {}
} // sensors

Vue.use(attentionPop)

// 在手机上打印输出
// import './utils/vconsoles.min'
// var vConsole = new VConsole()
// Vue.use(vConsole)

// Vue.use(Toast)
Vue.use(List)
Vue.use(Calendar)
Vue.use(PullRefresh)
Vue.use(Cell)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Dialog)

// 调用方法 this.$attentionPop.open()
Vue.config.devtools = true // 允许使用vueTools
Vue.prototype.bus = new Vue() // 使用总线机制进行组件间通信
Vue.prototype.$get = get // ajax get
Vue.prototype.$post = post // ajax post
Vue.prototype.$postForm = postForm // ajax post
Vue.prototype.$postPay = postPay // ajax post
Vue.prototype.$postKnowledge = postKnowledge // ajax post
Vue.prototype.$chaosiPost = chaosiPost

Vue.prototype.$utils = utils // 工具类
Vue.config.productionTip = false

global.memberId = localStorage.getItem('openId')
global.channelSign = sessionStorage.getItem('channelSign') || 'syrjia'
global.onlyVideo = sessionStorage.getItem('onlyVideo') || ''
global.isAttention = window.sessionStorage.isAttention
global.unionidState = localStorage.getItem('unionidState')
global.locations = window.location.href
global.base = '/syrjiaPatientEnd'

import './utils/vconsoles.min'
if (process.env.NODE_ENV == 'development') { // 判断是测试环境
  if (!localStorage.getItem('openId')) {
    localStorage.setItem('openId', 'obvYo0lkj2VsMUXFm65eOwu66qoQ')
    // (夏夏: o9X5RwYy_6ow7-I_VRtbLUP9RIrs)
    // (桂越: o9X5RwWHUCnMS5ZjhzLduNzTtmC4)
    // (萌萌: o9X5RwQQUAWz6xJv7u97-23cyMl0/oFb3cwsSmSjM2h-M5cSZ6o-OA6rA (pre2))
    // (斌宇: o9X5RwUKLbP3Kp4gnD9pFL3ADupo / o9X5RwZqpyftPTHi62g03-nHcMJI)
    // (方焦: oo_4L1Q9JNoeQGgFnM7zy3a4YKhk)
    // (文利: o9X5RwbiL2PjQHfvwRGbWAS4DnRk)
    // (薛~~: o9X5RwdtQSTPIJIoiemPfxskc7So)
    // (建新: o9X5RwZyBSFn3je6_2US9Rnp_n50)
  }
  localStorage.setItem('unionidState', '1.0.0')
  global.href = location.protocol + '//test-syrjia.syrjia.cn'
  global.fileHref = 'https://test-ossfile.syrjia.cn'
  // 在手机上打印输出
  var vConsole = new VConsole()
} else {
  global.href = location.protocol + '//' + location.host
  if (window.location.host == 'mobile.syrjia.com' || window.location.host == 'm.syrjia.com') {
    global.href = 'https://mobile.syrjia.com'
    global.fileHref = 'https://ossfile.syrjia.com'
    global.pkbaseUrl = 'http://store-mall.syrjia.com/pk_h5/' // 正式
  } else if (window.location.host == 'pre-syrjia.syrjia.cn' || window.location.host == 'pre2-syrjia.syrjia.cn') {
    global.fileHref = 'https://pre2-ossfile.syrjia.cn'
    global.pkbaseUrl = 'http://pre-syrjia.syrjia.cn/pk_h5/' // 预发
    // 在手机上打印输出
    var vConsole = new VConsole()
  } else if (window.location.host == 'test-syrjia.syrjia.cn' || window.location.host == 'test2-syrjia.syrjia.cn') {
    //临时正式验证，上线前必须还原
    //global.fileHref = 'https://ossfile.syrjia.com'
    global.fileHref = 'https://test2-ossfile.syrjia.cn'
    global.pkbaseUrl = 'http://test2-syrjia.syrjia.cn/pk_h5/' // 测试
    // 在手机上打印输出
    var vConsole = new VConsole()
  }
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// Vue.use(Vant)
// 自定义指令 修改页面的 title  使用方法  <div v-title data-title="dd"></div>
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js